import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import AboutPage from '../AboutPage/AboutPage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
// import ShopPage from '../ShopPage'
// import ProductSinglePage from '../ProductSinglePage';
// import CartPage from '../CartPage';
import CheckoutPage from '../CheckoutPage';
import OrderRecived from '../OrderRecived';
import FaqPage from '../FaqPage/FaqPage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectSingle from '../ProjectSingle/ProjectSingle';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import BlogPage from '../BlogPage/BlogPage'
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft'
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth'
import BlogDetails from '../BlogDetails/BlogDetails'
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide'
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull'
import ContactPage from '../ContactPage/ContactPage';
import ErrorPage from '../ErrorPage/ErrorPage';


const LegacyBlogRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/newsroom/${slug}`} replace />;
};

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/for-investors" element={<Homepage />} />
          <Route path="for-pharmacies" element={<HomePage2 />} />
          <Route path="/" element={<HomePage3 />} />
          <Route path="/home" element={<HomePage3 />} />
          <Route path="/about-us" element={<AboutPage />} />
          {/* <Route path="team" element={<TeamPage />} />
          <Route path="team-single/:slug" element={<TeamSinglePage />} /> */}
          {/* <Route path="shop" element={<ShopPage />} /> */}
          {/* <Route path='shop-single/:slug' element={<ProductSinglePage />} /> */}
          {/* <Route path='cart' element={<CartPage />} /> */}
          {/* <Route path='checkout' element={<CheckoutPage />} />
          <Route path='order_received' element={<OrderRecived />} /> */}
          {/* <Route path="faq" element={<FaqPage />} /> */}
          {/* <Route path="services" element={<ServicePages />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="project" element={<ProjectPage />} />
          <Route path="project-single/:slug" element={<ProjectSingle />} /> */}
          {/* <Route path='blog' element={<BlogPage />} />
          <Route path='blog-left-sidebar' element={<BlogPageLeft />} /> */}
          <Route path='newsroom' element={<BlogPageFullwidth />} />
          {/*  <Route path='newsroom/:slug/:id' element={<BlogDetails />} />
           <Route path='blog-single-left-sidebar/:slug' element={<BlogDetailsLeftSiide />} /> */}
          <Route path='newsroom/:slug' element={<BlogDetailsFull />} />
          {/* Legacy redirect: ensure old blog-single links go to newsroom */}
          <Route path='blog-single/:slug' element={<LegacyBlogRedirect />} />
          <Route path='contact-us' element={<ContactPage />} />
          {/*   <Route path='404' element={<ErrorPage />} />  */}
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
